<div mat-dialog-title [hotkey]="navigationHotkeys" class="case-modal-title">
	<div class="case-modal-header">
		<div class="case-modal-header-left">
			<a href="{{case.userId | userAvatarUrl}}?download=false" target="_blank">
				<img appUserAvatar="{{case.userId}}" [userName]="case.userName"
					style="width:60px; border:1px solid #ddd;"
					class="img-round img-fluid user-avatar-sm mr-3">
			</a>
			<div class="media-body">
				<div>{{case.userName}}</div>
				<div class="text-sm">{{case.currentPosition | titleRankStepTerm}}</div>
				<div *ngIf="showUserSeparationDate()" class="text-sm" style="color:maroon">Separation Date: {{formatSeparationDate()}}</div>
			</div>
		</div>
		<div *ngIf="!isNonAcademic(case)" class="case-year">{{case.year}}</div>
		<div *ngIf="!isNonAcademic(case)" class="case-modal-header-actions">
			<button
				class="btn btn-primary"
				[hidden]="!canPropose()"
				[matMenuTriggerFor]="proposalMenu">
					Propose an action
			</button>

			<mat-menu #proposalMenu="matMenu">
				<button
					mat-menu-item
					*ngFor="let t of actionProposalTypes"
					(click)="propose(t.value)">
						{{t.label}}
				</button>
			</mat-menu>

			<button class="btn btn-primary ml-2"
				(click)="sendToCandidate()"
				[hidden]="!canSendToCandidate()"
				matTooltip="Send the case to the candidate when you are ready for them to upload their case materials">
					Send case to candidate
			</button>

			<button class="btn btn-primary ml-2"
				(click)="approveDeferral()"
				[hidden]="!canApproveDeferral()"
				matTooltip="Approve Deferral for this candidate. This will close the review and disallow changes till next cycle.">
					Approve Deferral
			</button>

			<button class="btn btn-success ml-2"
				(click)="approve()"
				[hidden]="!canApprove()"
				matTooltip="Approve this person's proposed advancement">
					{{approvalLabel}}
			</button>
			<button class="btn btn-danger ml-2"
				(click)="denyFiveyearReview()"
				[hidden]="!canDenyFiveyearReview()"
				matTooltip="Deny this person's proposed five year review">
					{{denialLabel}}
			</button>
			<button
				class="btn btn-danger ml-2"
				[hidden]="!canDenyProposedAction()"
				[matMenuTriggerFor]="denialMenu"
				matTooltip="Deny this person's proposed advancement.  You will have the option to specify a secondary action.">
					{{denialLabel}}
			</button>

			<button
				class="btn btn-danger ml-2"
				[hidden]="!canDenyResult()"
				[matMenuTriggerFor]="denialMenu"
				matTooltip="Deny the decided result for this person's actions.  You will have the option to specify a secondary action.">
					Deny Result
			</button>

			<mat-menu #denialMenu="matMenu">
				<button
					mat-menu-item
					*ngFor="let o of denialOptions"
					(click)="deny(o.value)">
						{{o.label}}
				</button>
			</mat-menu>

			<button class="btn btn-warning ml-2"
				(click)="recallCase()"
				[hidden]="!canRecall()"
				matTooltip="Recall the case from the candidate">
					Recall case
			</button>

			<button class="btn btn-warning ml-2"
				(click)="appealResult()"
				[hidden]="!canAppealResult()"
				matTooltip="Appeal the result so a different one can be assigned">
					Appeal Result
			</button>

			<button class="btn btn-warning ml-2"
				(click)="retryStalledCase()"
				[hidden]="!canRetryStalledCase()"
				matTooltip="Retry advancing the stalled workflow (e.g., after adding a missing supervisor)">
					Retry Workflow
			</button>
		</div>
	</div>
	<ul class="nav nav-tabs mt-3" style="font-size:0.75em; font-weight:normal;">
		<li *ngFor="let tab of tabs" class="nav-item">
			<a class="nav-link" href="javascript:void(0)"
			[class.active]="tab == activeTab"
			(click)="activateTab(tab)">
				{{tab.label}}<span *ngIf="tab.id === 'case_tasks' && hasDrift" class="badge badge-danger ml-1" title="Reviewer tasks are out of sync">!</span>
			</a>
		</li>
	</ul>
</div>

<style>
	.table-border-top-none > tr:first-child > th,
	.table-border-top-none > tr:first-child > td,
	.table-border-top-none > tbody > tr:first-child > th,
	.table-border-top-none > tbody > tr:first-child > td {
		border-top: none;
	}
	.table-border-top-none .table > tr:first-child > th,
	.table-border-top-none .table > tr:first-child > td,
	.table-border-top-none .table > thead > tr:first-child > th {
		border-top: none;
		border-bottom-width: 1px;
	}
</style>


<mat-dialog-content style="min-height: 300px;">
	<div class="row">
		<div [ngClass]="showHistorySidebar ? 'col-7' : 'col-12'" [ngSwitch]="activeTab.id">
			<ng-container *ngSwitchCase="'candidate_docs'">
				<p>
					<i class="fa fa-fw fa-info-circle"></i>
					These are the document requirements that the candidate would see in wfa
					based on the current proposed action.
				</p>
				
				<table class="table table-bordered table-sm text-sm">
					<tr>
						<th>Document</th>
						<th>Requirement</th>
					</tr>
					<tr *ngFor="let d of case.candidateDocuments" [title]="d.description">
						<td>
							{{d.name}}
						</td>
						<td>
							{{d.requirement}}
						</td>
					</tr>
					<tr>
						<td>
							Letters of Evaluation
						</td>
						<td [ngSwitch]="case.lettersOfEvaluation.type">
							<div *ngSwitchCase="'Required'">
								Required 
								<button
									class="btn btn-sm btn-link text-xs"
									(click)="preview(case.lettersOfEvaluation.message)">
										Preview Request
								</button>
							</div>
							<div *ngSwitchDefault>
								Not Required
							</div>
						</td>
					</tr>
				</table>
			</ng-container>
			<ng-container *ngSwitchCase="'county_assignments'">
				<div class="list-group">
					<div class="list-group-item text-muted" *ngIf="!case.countyAssignments.length">
						No assignments yet
					</div>
					<div class="list-group-item" *ngFor="let a of case.countyAssignments; trackBy:getId">
						{{a.name}}
						<button class="btn btn-link btn-sm float-right"
						(click)="removeCountyAssignment(a)">
							Remove
						</button>
					</div>
					<div class="list-group-item">
						<form class="form-inline">
							<select class="form-control form-control-original col mr-3"
							[(ngModel)]="selectedCountyId"
							[ngModelOptions]="{standalone: true}">
								<option value="" disabled selected>
									Select a County
								</option>
								<option *ngFor="let c of availableCounties" [value]="c.id">
									{{c.name}}
								</option>
							</select>
							<button class="btn btn-primary col" [disabled]="!selectedCountyId"
							(click)="addCountyAssignment(selectedCountyId); selectedCountyId = undefined;">
								Add Assignment
							</button>
						</form>
					</div>
				</div>
			</ng-container>
			<ng-container *ngSwitchCase="'supervisors'">
				<table class="table table-sm">
					<tr *ngFor="let s of case.supervisors; let index=index">
						<td>
							{{s.details.name}}
							<!--
							<br>
							{{supervisorReviewParticipationLabelById[s.reviewParticipation]}}
							-->
							<div class="text-sm text-muted">
								{{n_ary(index+1)}}
							</div>
						</td>
						<td>
							<label class="form-check-label">
								<select class="form-control text-sm" (change)="supervisorReviewParticipationChange(index, $event)">
									<option *ngFor="let o of supervisorReviewParticipationOptions" [value]="o.id" [selected]="s.reviewParticipation === o.id">
										{{o.label}}
									</option>
								</select>
							</label>
						</td>
						<td>
							<button class="btn btn-link btn-sm" (click)="promoteSupervisor(s,index)">
								Promote
							</button>
						</td>
						<td>
							<button class="btn btn-link btn-sm" (click)="demoteSupervisor(s,index)">
								Demote
							</button>
						</td>
						<td>
							<button class="btn btn-link btn-sm" (click)="removeSupervisor(s,index)">
								Remove
							</button>
						</td>
					</tr>
				</table>
				<user-picker 
					[formControl]="usersControl"
					enableNonANRCollaborator="false"
					selectSingle="true"
					[showUserIds]="true"></user-picker>
				<div class="form-check form-check-tight">
					<label class="form-check-label" *ngFor="let o of supervisorReviewParticipationOptions">
						<input class="form-check-input" 
							name="supervisorInvolvement"
							type="radio"
							[value]="o.id"
							[formControl]="supervisorReviewInvolvementControl">
						{{o.label}} - {{o.description}}
					</label>
					
				</div>
				<button 
					class="btn btn-secondary"
					(click)="addSupervisor(usersControl.value.toArray()[0], supervisorReviewInvolvementControl.value); usersControl.value.clear()"
					[disabled]="usersControl.value.toArray().length != 1">
						Add Supervisor
				</button>
			</ng-container>
			<ng-container *ngSwitchCase="'case'">
				<table *ngIf="!isNonAcademic(case)" class="table table-border-top-none">
					<tr>
						<th>Status</th>
						<td>
							{{case.state | caseState}}
							<span *ngIf="workflowStageLabel" class="text-muted ml-1">({{workflowStageLabel}})</span>
							<a *ngIf="hasActiveWorkflow"
								[routerLink]="'/review/packet/' + activeWorkflowCase.caseId"
								target="_blank"
								class="btn btn-sm btn-outline-primary ml-2">
									View in workflow
							</a>
							<div *ngIf="activeWorkflowCase?.stallReason" class="text-danger text-sm mt-1">
								{{activeWorkflowCase.stallReason}}
							</div>
						</td>
					</tr>
					<ng-container [ngSwitch]="case.eligibleActions.length">
						<tr *ngSwitchDefault>
							<th>
								Eligible Action(s)
							</th>
							<td>
								<table class="table table-sm">
									<tr>
										<th style="width:50%;">Type</th>
										<th>Period of Review</th>
									</tr>
									<tr *ngFor="let a of case.eligibleActions">
										<td>
											{{a.type | actionTypeName}}
										</td>
										<td>
											<small [ngSwitch]="!!a.truePeriodOfReview.value">
												<ng-container *ngSwitchCase="true">
													{{a.truePeriodOfReview.value.start | date}} - {{a.truePeriodOfReview.value.end | date}}
												</ng-container>
												<ng-container *ngSwitchCase="false">
													N/A
												</ng-container>
											</small>
										</td>
									</tr>
								</table>
							</td>
						</tr>
					</ng-container>

					<tr>
						<th>Proposed Action</th>
						<td [ngSwitch]="!!case.proposedAction.value">
							<div *ngSwitchCase="true">
								<table class="table table-sm">
									<tr>
										<td style="width:50%;">
											<proposed-action [caseAdvancement]="case.asCaseAdvancement()"></proposed-action>
										</td>
										<td>
											<small [ngSwitch]="!!case.proposedAction.value.truePeriodOfReview.value">
												<ng-container *ngSwitchCase="true">
													{{case.proposedAction.value.truePeriodOfReview.value.start | date}} - {{case.proposedAction.value.truePeriodOfReview.value.end | date}}
												</ng-container>
												<ng-container *ngSwitchCase="false">
													N/A
												</ng-container>
											</small>
										</td>
									</tr>
								</table>
							</div>
							<div *ngSwitchCase="false" class="text-muted">
								None Yet
							</div>
						</td>
					</tr>
					<tr>
						<th>Proposed&nbsp;Position</th>
						<td [ngSwitch]="!!case.proposedAction.value">
							<div *ngSwitchCase="true">
								{{case.proposedAction.value.endingPosition | titleRankStepTerm}}
							</div>
							<div *ngSwitchCase="false" class="text-muted">
								N/A
							</div>
						</td>
					</tr>
					<tr *ngIf="canToggleAdminAssignment()">
						<th>Admin Assignment</th>
						<td>
							<label class="mb-0">
								<input #adminAssnChk type="checkbox"
									[checked]="activeWorkflowCase.hasAdminAssignment"
									(change)="toggleAdminAssignment(adminAssnChk.checked)" />
								Allows an extra page on the Program Summary Narrative
							</label>
						</td>
					</tr>
					<tr *ngIf="case.reviewSteps.length > 0">
						<th title="These are the review steps the case goes through">
							Review Steps
							<i class="fa fa-fw fa-info-circle"></i>
						</th>
						<td>
							<review-steps-editor [case]="case" (changed)="onReviewStepsChanged()"></review-steps-editor>
						</td>
					</tr>
					<tr>
						<th>Time Served</th>
						<td>
							<time-served-table [data]="case.timeServed"></time-served-table>
						</td>
					</tr>
					<tr>
						<th>Start dates</th>
						<td [ngSwitch]="!!case.startDates.value">
							<div class="text-muted" *ngSwitchCase="false">
								None on record
							</div>
							<table class="table table-sm" *ngSwitchCase="true">
								<tr *ngFor="let row of [
									{
										key: 'currentTitle',
										label: 'Current Title'
									},
									{
										key: 'currentRank',
										label: 'Current Rank'
									},
									{
										key: 'currentStep',
										label: 'Current Step'
									}
								]" >
									<td>{{row.label}}</td>
									<td>{{case.startDates.value[row.key] | date : 'MMMM d, yyyy'}}</td>
								</tr>
							</table>
						</td>
					</tr>
				</table>
				<table *ngIf="isNonAcademic(case)" class="table table-border-top-none">
					<tr>
						<th>Start dates</th>
						<td [ngSwitch]="!!case.startDates.value">
							<div class="text-muted" *ngSwitchCase="false">
								None on record
							</div>
							<table class="table table-sm" *ngSwitchCase="true">
								<tr *ngFor="let row of [
									{
										key: 'currentTitle',
										label: 'Current Title'
									}
								]" >
									<td>{{row.label}}</td>
									<td>{{case.startDates.value[row.key] | date : 'MMMM d, yyyy'}}</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr><th></th><td></td></tr> <!-- added to create a border -->
				</table>

			</ng-container>
			<ng-container *ngSwitchCase="'academic_info'">
				<table class="table table-sm">
					<tr>
						<td>
							<h6 style="margin-top: 15px;">Separation Date</h6>
						</td>
						<td>
							<div class="input-group input-group-sm no-padding">
								<input [matDatepicker]="userSeparationDate" placeholder="mm/dd/yyyy" [(ngModel)]="case.userSeparationDate" class="form-control form-control-sm no-padding"
										(dateInput)="userSeparationDateChg($event)" readonly>
								<mat-datepicker #userSeparationDate startView="month"></mat-datepicker>
								<mat-datepicker-toggle [for]="userSeparationDate" class="input-group-addon no-padding mat-icon-overide"></mat-datepicker-toggle>
							</div>
						</td>
						<td>
							<button class="btn btn-secondary" style="margin-top: 10px;" (click)="saveUserSeparationDate()">Save</button>
							<button class="btn btn-secondary" style="margin-top: 10px;" (click)="clearUserSeparationDate()">Clear</button>
						</td>
					</tr>
				</table>
			</ng-container>
			<div *ngSwitchCase="'case_tasks'">
				<div *ngIf="reconciliationLoading">Loading…</div>
				<div *ngIf="!reconciliationLoading && (!reconciliation || reconciliation.stages.length === 0)" class="text-muted">
					No workflow tasks to reconcile for this case.
				</div>
				<ng-container *ngIf="!reconciliationLoading && reconciliation && reconciliation.stages.length > 0">
					<div *ngFor="let stage of reconciliation.stages" class="mb-4">
						<h6 class="mb-2">{{ stage.stage }}</h6>
						<table class="table table-sm">
							<thead><tr><th>Reviewer</th><th>Email</th><th>Status</th></tr></thead>
							<tbody>
								<tr *ngFor="let t of stage.tasks">
									<td>{{ t.name }}</td><td>{{ t.email }}</td><td>{{ t.status }}</td>
								</tr>
								<tr *ngIf="stage.tasks.length === 0"><td colspan="3" class="text-muted">No tasks</td></tr>
							</tbody>
						</table>
						<div *ngIf="stage.changes.length > 0" class="mt-2">
							<div class="font-weight-bold text-danger mb-1">Pending changes</div>
							<div *ngFor="let ch of stage.changes" class="form-check">
								<input class="form-check-input" type="checkbox"
									[id]="'recon-' + stage.stage + '-' + ch.kind + '-' + ch.userId"
									[checked]="isChangeSelected(ch)" (change)="toggleChange(ch)">
								<label class="form-check-label" [for]="'recon-' + stage.stage + '-' + ch.kind + '-' + ch.userId">
									{{ changeKindLabel(ch.kind) }}: {{ ch.name }} <span class="text-muted">({{ ch.email }})</span>
								</label>
							</div>
						</div>
					</div>
					<button class="btn btn-primary btn-sm" [disabled]="!hasSelectedChanges || reconciliationApplying" (click)="applyReconciliation()">
						Apply selected changes
					</button>
				</ng-container>
			</div>
			<ng-container *ngSwitchCase="'history'">
				<ng-container *ngTemplateOutlet="historyPanel"></ng-container>
			</ng-container>
		</div>

		<div class="col-5" *ngIf="showHistorySidebar">
			<ng-container *ngTemplateOutlet="historyPanel"></ng-container>
		</div>
	</div>

	<ng-template #historyPanel>
		<div class="list-group text-sm">
			<div class="mb-2">
				<strong class="text-muted text-sm">
					History
				</strong>
			</div>
			<div [hidden]="!!news">
				Loading history...
			</div>
			<div class="list-group-item" *ngFor="let story of news">
				<span *ngFor="let e of story.elements" [ngSwitch]="e.case">
					<span *ngSwitchCase="'By'">
						{{e.user.name}}
						<span *ngIf="!!e.onBehalfOf.value">
							(on behalf of {{e.onBehalfOf.value}})
						</span>
					</span>
					<span *ngSwitchCase="'Text'">
						{{e.text}}
					</span>
					<span *ngSwitchCase="'Academic'">
						this person
					</span>
					<span *ngSwitchCase="'Supervisor'">
						{{e.supervisor.name}}
					</span>
				</span>
				<div class="float-right">
					<span class="text-muted" [title]="story.timestamp | date : 'EEEE, MMMM d yyyy @ h:mm:ss a'">
						{{story.timestamp | timeAgo}}
					</span>
				</div>
			</div>
		</div>
	</ng-template>
</mat-dialog-content>
<mat-dialog-actions [hotkey]="navigationHotkeys">
	<style>
		.hidden-until-hovered {
			opacity: 0;
		}
		.hidden-until-hovered:hover {
			opacity: 1;
		}
	</style>
	<div class="btn-group float-left">
		<button class="btn btn-secondary"
			[disabled]="!navigator.hasPrev()"
			(click)="navigator.goPrev(this)"
			[title]="'Previous case' + (!navigator.hasPrev() ? ' (Disabled; you are viewing the first case)' : '')">
				<i class="fa fa-fw fa-chevron-left"></i>
		</button>
		<button class="btn btn-secondary"
			[disabled]="!navigator.hasNext()"
			(click)="navigator.goNext(this)"
			[title]="'Next case' + (!navigator.hasNext() ? ' (Disabled; you are viewing the last case)' : '')">
				<i class="fa fa-fw fa-chevron-right"></i>
		</button>
	</div>
	<code
		style="float: left; top: 4px; position: relative;"
		class="text-sm text-muted hidden-until-hovered">
			ID = {{case.id}}
	</code>

	<button (click)="close()" class="btn btn-link">
		Close
	</button>
</mat-dialog-actions>